var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.5 1l2.204 4.466 4.929.716-3.566 3.476.842 4.909L8.5 12.25l-4.408 2.318.842-4.909-3.566-3.476 4.929-.716L8.5 1z","stroke":"#0a1c33","strokeWidth":"2","strokeLinejoin":"round"}));
}

Star.defaultProps = {"width":"13","height":"13","viewBox":"0 0 17 16","fill":"none"};

module.exports = Star;

Star.default = Star;
